export function confirmMessageArchive(_campaign: { name: string }): string {
  return `Archiving will remove this campaign from the Texter View. Texters will no longer be able to claim replies or send messages, but Supervolunteers, Admins and Org Owners can still access and send messages on threads from the Threads page.`;
}

export function confirmMessageUnarchive(campaign: { name: string }): string {
  return `Are you sure you want to unarchive the campaign "${campaign.name}"?`;
}
